<div class="mce-dialog">
  <div class="mce-dialog__header">
    <mat-icon class="mce-dialog__icon">credit_card</mat-icon>
    <div>
      <h2 class="mce-dialog__title">Manual Card Entry</h2>
      <p class="mce-dialog__subtitle">{{ data.businessName || '' }}</p>
    </div>
  </div>

  <mat-divider></mat-divider>

  <div class="mce-dialog__body">
    <div class="mce-dialog__total-row">
      <span>Amount</span>
      <span class="mce-dialog__total-amount">{{ formatCents(data.amount) }}</span>
    </div>

    <div class="mce-dialog__loading" *ngIf="loadingSdk && !sdkError">
      <mat-spinner diameter="36"></mat-spinner>
      <p>Loading secure card entry…</p>
    </div>

    <div class="mce-dialog__error" *ngIf="sdkError">
      <mat-icon>error_outline</mat-icon>
      <span>{{ sdkError }}</span>
    </div>

    <form class="mce-dialog__form" [hidden]="loadingSdk || sdkError" autocomplete="off">
      <label class="mce-dialog__label">Card Number</label>
      <div id="mce-card-number" class="mce-dialog__field"></div>

      <div class="mce-dialog__row">
        <div class="mce-dialog__col">
          <label class="mce-dialog__label">Expiration</label>
          <div id="mce-card-date" class="mce-dialog__field"></div>
        </div>
        <div class="mce-dialog__col">
          <label class="mce-dialog__label">CVV</label>
          <div id="mce-card-cvv" class="mce-dialog__field"></div>
        </div>
        <div class="mce-dialog__col">
          <label class="mce-dialog__label">ZIP</label>
          <div id="mce-card-postal" class="mce-dialog__field"></div>
        </div>
      </div>

      <div class="mce-dialog__error mce-dialog__error--inline" *ngIf="errorMessage">
        <mat-icon>error_outline</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>
    </form>
  </div>

  <mat-divider></mat-divider>

  <div class="mce-dialog__actions">
    <button mat-button class="btn-cancel" (click)="cancel()" [disabled]="submitting">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      class="btn-charge"
      (click)="submit()"
      [disabled]="submitting || !formReady">
      <mat-spinner *ngIf="submitting" diameter="20" class="charge-spinner"></mat-spinner>
      <span *ngIf="!submitting">Charge {{ formatCents(data.amount) }}</span>
    </button>
  </div>
</div>
